<div [class]="'d-inline-flex label ' + color">
    <div class="d-flex align-items-center">
        <img *ngIf="icon === 'checkmark'" class="icon" src="../../../assets/icons/check_mark.svg" width="14" height="11">
        <h4><ng-content></ng-content></h4>
    </div>
</div>